import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { MessageCircle } from 'lucide-react';
import { api } from '../context/AuthContext';

export default function MessageIndicator() {
  const [unreadCount, setUnreadCount] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    fetchUnreadCount();
    const interval = setInterval(fetchUnreadCount, 30000);
    return () => clearInterval(interval);
  }, []);

  const fetchUnreadCount = async () => {
    try {
      const response = await api.get('/wants-conversations/unread-count');
      setUnreadCount(response.data?.count || 0);
    } catch {
      // silently fail
    }
  };

  return (
    <button
      onClick={() => { setUnreadCount(0); navigate('/wants-chat'); }}
      className="relative p-2 hover:bg-gray-100 rounded-full transition"
      title="Mensajes"
    >
      <MessageCircle className="w-6 h-6" />
      {unreadCount > 0 && (
        <span className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 text-white text-xs rounded-full flex items-center justify-center font-bold animate-pulse">
          {unreadCount > 9 ? '9+' : unreadCount}
        </span>
      )}
    </button>
  );
}
